export default __webpack_public_path__ + "static/media/bar-border-crossing.16eed9e0.svg";